<template>
    <v-row justify-center @click.stop>
        <v-col>
            <v-dialog v-model="dialog" persistent max-width="500">
                <v-card>
                    <v-toolbar flat dense :color="type">
                        <v-spacer></v-spacer>
                        <v-toolbar-title>{{ type | capitalize }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text class="mt-4">{{ textMsg }}</v-card-text>
                    <v-card-actions>
                        <v-row no-gutters justify-center>
                            <v-col  v-if="alertType == alertTypes.ERROR">
                                <v-btn color="primary" @click.stop="ok">Ok</v-btn>
                            </v-col>
                            <v-col v-else>
                                <v-btn color="default" text @click.stop="close">Cancel</v-btn>
                                <v-btn color="primary" @click.stop="ok">Agree</v-btn>
                            </v-col>
                        </v-row>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-col>
    </v-row>
</template>

<script>
    import {ALERT_TYPES} from "@/shared/enums/AlertTexts";

    export default {
        name: "DialogAlert",
        props:['text', 'open', 'alertType'],
        data(){
            return {
                dialog: this.open,
                alertTypes: ALERT_TYPES,
                textMsg: this.text,
                type: this.alertType
            }
        },
        filters: {
            capitalize: function (value) {
                if (!value) return ''
                value = value.toString()
                return value.charAt(0).toUpperCase() + value.slice(1)
            }
        },
        computed:{
            textToShow(){
                return this.text;
            },
        },
        watch:{
            open(newValue){
                this.dialog = newValue;
            },
            text(newValue){
                this.textMsg = newValue;
            },
            alertType(newValue){
                this.type = newValue;
            }
        },
        methods:{
            ok(){
                this.dialog = false;
                this.$emit('alert-closed', true);
            },
            close(){
                this.dialog = false;
                this.$emit('alert-closed', false);
            }
        }
    }
</script>

<style scoped>

</style>